// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Fault timer event type — enum, not string. 1 byte.
 */
export enum FaultTimerAction {
  Start = 0,
  Cancel = 1,
  Expire = 2,
}
